import { render } from "./SidebarDocumentation.vue?vue&type=template&id=b91e6bb6"
import script from "./SidebarDocumentation.vue?vue&type=script&lang=js"
export * from "./SidebarDocumentation.vue?vue&type=script&lang=js"

import "./SidebarDocumentation.vue?vue&type=style&index=0&id=b91e6bb6&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__